"use client";
import { createContext } from 'react';

const LazyContext = createContext({ strict: false });

export { LazyContext };
//# sourceMappingURL=LazyContext.mjs.map
